// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"299":"58be9f94","453":"a78d0959"}[chunkId] + ".chunk.js";
};